import React from 'react';
// custom imports
import '../../../assets/css/Login.css';
// 3rd party imports
import { AuthClient } from '@dfinity/auth-client';
import { Spin } from 'antd';
import Profile from './Profile';
const Login = () => {
    const [isLogin, setIsLogin] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    async function handleAuthenticated(authClient) {
        await authClient.getIdentity();
        setIsLogin(true);
    }
    React.useEffect(async () => {
        const authClient = await AuthClient.create();
        if (await authClient.isAuthenticated()) {
            handleAuthenticated(authClient);
        }
    }, []);
    const handleLogin = async () => {
        setLoading(true);
        const authClient = await AuthClient.create();
        await authClient.login({
            onSuccess: async () => {
                handleAuthenticated(authClient);
            },
            //identityProvider: 'http://localhost:8000/?canisterId=rwlgt-iiaaa-aaaaa-aaaaa-cai',
        });
    };
    return (React.createElement("div", { className: "login-container" },
        React.createElement("div", { id: "bg" },
            React.createElement("img", { src: "./images/back.jpg", alt: "" })),
        isLogin
            ? React.createElement(Profile, null)
            : (React.createElement("div", { className: "login" },
                React.createElement("div", { className: "login-LHS" },
                    React.createElement("div", { id: "login-content" },
                        React.createElement("div", { id: "ic-title" }, "clandestine"),
                        React.createElement("div", { id: "ic-footer" }, "Decentralized Gaming Hub"))),
                React.createElement("div", { className: "login-RHS" }, loading
                    ? (React.createElement("div", { className: "login-div" },
                        React.createElement("div", { id: "login-button-loading" },
                            React.createElement(Spin, null))))
                    : (React.createElement("div", { className: "login-div", role: "button", tabIndex: 0, onClick: () => handleLogin() },
                        React.createElement("div", { id: "login-button" },
                            "Login with \u00A0\u00A0",
                            ' ',
                            React.createElement("img", { src: "./icons/dfinity.png", alt: "dfinity logo", style: { height: '16px' } }))))),
                React.createElement("div", { className: "RHS-mobile" }, loading
                    ? (React.createElement("div", { className: "block" },
                        React.createElement("div", { className: "top" },
                            React.createElement("p", { id: "ic-title" }, "clandestine"),
                            React.createElement("p", { id: "ic-footer" }, "Decentralized Gaming Hub")),
                        React.createElement("div", { className: "login-div" },
                            React.createElement("div", { id: "login-button-loading" },
                                React.createElement(Spin, null)))))
                    : (React.createElement("div", { className: "block" },
                        React.createElement("div", { className: "top" },
                            React.createElement("p", { id: "ic-title" }, "clandestine"),
                            React.createElement("p", { id: "ic-footer" }, "Decentralized Gaming Hub")),
                        React.createElement("div", { className: "login-div", role: "button", tabIndex: 0, onClick: () => handleLogin() },
                            React.createElement("div", { id: "login-button" },
                                "Login with \u00A0\u00A0",
                                ' ',
                                React.createElement("img", { src: "./icons/dfinity.png", alt: "dfinity logo", style: { height: '16px' } }))))))))));
};
export default Login;
